import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'

import TableSkeleton from '@/components/table-skeleton'
import { useGetEconomyReports } from '@/hooks/queries/use-get-economy-reports'

import { EmptyComponent } from '../components/empty-component'
import { Row } from './row'
import { useStyles } from './styles'

export default function EconomyIndicators() {
  const classes = useStyles()

  const { data, isPreviousData, isFetching } = useGetEconomyReports()

  const isFetchingMore = (isPreviousData && isFetching) || !data

  return data && !data.length ? (
    <EmptyComponent
      title='Nenhum relatório disponível'
      subtitle='Não há nenhum relatório contendo seus indicadores de economia disponível, contate a Equipe Cromai para confeccionar seus relatórios.'
    />
  ) : (
    <>
      <Typography variant='h1'>Indicadores de economia</Typography>
      <Box height='100%' overflow='auto'>
        <Table padding='none' className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Data de relatório
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Nome do arquivo
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Período dos resultados
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Tags
                </Typography>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          {isFetchingMore ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={5}>
                  <TableSkeleton />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {data.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          )}
        </Table>
      </Box>
    </>
  )
}
